import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import HelperReducer from "./HelperReducer";
import AdminReducer from "./AdminReducer";
import AgentReducer from "./AgentReducer";
import PropertyReducer from "./PropertyReducer";
import InvoiceReducer from "./InvoiceReducer";
import TodoAppReducer from "./TodoAppReducer";
import DashboardReducer from "./DashboardReducer";
import RaportReducer from "./RaportReducer";
import AccountReducer from "./AccountReducer";
import ProjectReducer from "./ProjectReducer";
import Property_Reducer from "../reducers_agent/PropertyReducer";
import Invoice_Reducer from "../reducers_agent/InvoiceReducer";
import Dashboard_Reducer from "../reducers_agent/DashboardReducer";
import Masrufat_Reducer from "../reducers_agent/MasrufatReducer";
import TodoApp_Reducer from "../reducers_agent/TodoAppReducer";
import Raport_Reducer from "../reducers_agent/RaportReducer";
import Auth_Reducer from "../reducers_agent/AuthReducer";
import Project_Reducer from "../reducers_agent/ProjectReducer";
const RootReducer = combineReducers({
  AuthReducer,
  HelperReducer,
  AdminReducer,
  AgentReducer,
  PropertyReducer,
  InvoiceReducer,
  TodoAppReducer,
  DashboardReducer,
  RaportReducer,
  AccountReducer,
  ProjectReducer,
  Property_Reducer,
  Invoice_Reducer,
  Dashboard_Reducer,
  Masrufat_Reducer,
  TodoApp_Reducer,
  Raport_Reducer,
  Auth_Reducer,
  Project_Reducer,
});

export default RootReducer;
